'use client';

import { runningClientSide } from '@benzinga/utils';

export const useEffectReadyState = (action: () => void, states: DocumentReadyState[]): void => {
  if (!runningClientSide()) {
    return;
  }

  const ifStateMatch = () => {
    return states.some(state => document?.readyState === state);
  };

  if (ifStateMatch()) {
    action();
  } else {
    window?.addEventListener('readystatechange', () => {
      if (ifStateMatch()) {
        action();
      }
    });
  }
};
